export const onServiceWorkerUpdateReady = () => {
  const answer = window.confirm(`当前页面发布了更新的版本，是否刷新获取更好的体验?`)
  if (answer === true) {
    window.location.reload()
  }
}
